module.exports = __webpack_public_path__ + "media/images/clients/client_baner@2x-8a71ad8434d1a0ca6a02743f78e1e35b.png";